import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { SelectionSettingsModel, ToolbarItems, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';

import { GridPageSettings, LocalStorageKeys, MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { MenuFuncionService, GastoService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-gastoRankingServicios',
  templateUrl: './gastoRankingServicios.component.html',
  styleUrls: ['./gastoRankingServicios.component.scss']
})

export class GastoRankingServiciosComponent implements OnInit,OnDestroy {

  isValidating: boolean = false;
  canView: boolean = false;
  isSearching: boolean = false;
  formGroup: FormGroup;

  public data: DataManager;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private gastoService: GastoService,
    private formBuilder: FormBuilder,
    private menuService: MenuFuncionService,
    private router: Router,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
   }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_GASTOS_RANKING_SERVICIO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }
  
  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList ;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    

    this.setQueryParams();
    this.data = new DataManager({
      url: this.gastoService.getServiceUrl() + '/dashboard-ranking-servicios',
      adaptor: new WebApiAdaptor(),
      headers: [this.gastoService.getAuthorizationHeader(),this.gastoService.getTenantHeader()]
    });
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    if (cId != null && cId > 0) {
      var index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
      if (index >= 0)
        this.query.params[index].value = cId;
      else
        this.query.addParams("ConsorcioId", cId);
    }
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
